import React from "react";
import { Link } from "react-router-dom";

// Bootstrap components
import Col from "react-bootstrap/Col";

// Custom CSS
import "./orderList.styles.scss";

// Utils
import formatMoney from "../../utils/formatMoney";

const getOrderStatus = (order) => {
  if (order.shipping?.deliveredAt) return 'delivered';
  if (order.shipping?.shippedAt) return 'shipped';
  if (order.shipping?.trackingNumber) return 'processing';
  return 'pending';
};

const getOrderStatusText = (order) => {
  if (order.shipping?.deliveredAt) return 'Entregado';
  if (order.shipping?.shippedAt) return 'En camino';
  if (order.shipping?.trackingNumber) return 'En proceso';
  return 'Pendiente';
};

export default function OrderList({ orderItems }) {
  // console.log(orderItems);
  return orderItems?.map((item, key) => (
    <Col xs="12" lg="4" className="orders__container__list" key={key}>
      <Link to={`/profile/orders/${item.orderId}`} className="order-card">
        <div className="order-card__header">
          <div className="order-id">
            <span className="label">Orden #{item.orderId}</span>
            <span className={`status ${getOrderStatus(item)}`}>
              {getOrderStatusText(item)}
            </span>
          </div>
          <div className="order-date">
            {new Date(item.createdAt).toLocaleDateString("es-MX", {
              year: "numeric",
              month: "long",
              day: "numeric",
              hour: "2-digit",
              minute: "2-digit",
            })}
          </div>
        </div>

        <div className="order-card__products">
          {item.orderItems.map((orderItem, index) => (
            <div key={index} className="product-item">
              <span className="product-name">{orderItem.product.nombre}</span>
              <span className="product-quantity">x{orderItem.quantity}</span>
            </div>
          ))}
        </div>

        <div className="order-card__shipping">
          <div className="shipping-method">
            <i className="fas fa-shipping-fast"></i>
            <span>
              {item.shipping?.method === 'premium' && 'Envío Gratuito Premium'}
              {item.shipping?.method === 'express' && 'Envío Express'}
              {item.shipping?.method === 'overnight' && 'Entrega al Día Siguiente'}
            </span>
          </div>
          {item.shipping?.trackingNumber && (
            <div className="tracking-number">
              <i className="fas fa-barcode"></i>
              <span>#{item.shipping.trackingNumber}</span>
            </div>
          )}
        </div>

        <div className="order-card__footer">
          <div className="total-amount">
            <span className="label">Total</span>
            <span className="amount">{formatMoney(item.total)} MXN</span>
          </div>
          <div className="view-details">
            Ver detalles <i className="fas fa-chevron-right"></i>
          </div>
        </div>
      </Link>
    </Col>
  ));
}
